<div class="card border-0 shadow-sm notifications-settings-card">
  <div class="card-header bg-white">
    <h5 class="mb-1 fw-semibold">
      <i class="bi bi-bell-fill text-primary me-2"></i>
      Notification Preferences
    </h5>

    <small class="text-muted">
      Control how the practice keeps patients informed about their upcoming appointments.
    </small>
  </div>

  <div class="card-body">
    @if (isLoading) {
      <div class="text-center py-4 text-muted">
        <div class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></div>
        Loading notification settings...
      </div>
    } @else {
      <div class="alert alert-info d-flex align-items-start notifications-note">
        <i class="bi bi-info-circle-fill me-2 mt-1"></i>
        <div>
          Appointment reminders help patients arrive prepared and reduce missed bookings without
          adding manual follow-up work.
        </div>
      </div>

      <div class="row g-3 mb-4">
        <div class="col-md-4">
          <div class="card notification-metric h-100 border-0">
            <div class="card-body">
              <div class="text-muted small mb-1">Email Reminders</div>
              <div class="fs-4 fw-bold">
                {{ notificationSettings.patientAppointmentEmailReminder ? 'Enabled' : 'Disabled' }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card notification-metric h-100 border-0">
            <div class="card-body">
              <div class="text-muted small mb-1">Reminder Timing</div>
              <div class="fs-4 fw-bold">{{ notificationSettings.reminderHoursBefore }}h Before</div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card notification-metric h-100 border-0">
            <div class="card-body">
              <div class="text-muted small mb-1">Delivery Channel</div>
              <div class="fs-4 fw-bold">Email</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border-0 bg-light notification-form-card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-1 fw-semibold">Appointment Email Reminders</h6>
              <small class="text-muted"
                >Automatically notify patients before their scheduled appointments.</small
              >
            </div>

            <div class="form-check form-switch">
              <input
                class="form-check-input fs-5"
                type="checkbox"
                id="appointmentEmailReminder"
                [(ngModel)]="notificationSettings.patientAppointmentEmailReminder"
              />
            </div>
          </div>

          <div class="row g-3 align-items-end">
            <div class="col-lg-6">
              <label class="form-label fw-semibold"> Send Reminder </label>

              <select
                class="form-select"
                [(ngModel)]="notificationSettings.reminderHoursBefore"
                [disabled]="!notificationSettings.patientAppointmentEmailReminder"
              >
                <option [ngValue]="1">1 Hour Before</option>

                <option [ngValue]="2">2 Hours Before</option>

                <option [ngValue]="6">6 Hours Before</option>

                <option [ngValue]="12">12 Hours Before</option>

                <option [ngValue]="24">24 Hours Before</option>

                <option [ngValue]="48">48 Hours Before</option>
              </select>

              <small class="text-muted d-block mt-2">
                Choose how far ahead patients receive their appointment email.
              </small>
            </div>

            <div class="col-lg-6">
              <div class="notification-sidebar rounded-3 p-3">
                <div class="fw-semibold mb-2">Recommended Timing</div>
                <small class="text-muted d-block">
                  A 24-hour reminder gives patients enough notice while still keeping the
                  appointment top of mind.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (!isLoading) {
    <div
      class="card-footer bg-white d-flex justify-content-between align-items-center flex-wrap gap-2"
    >
      <small class="text-muted">
        Saved preferences apply to future patient appointment reminders.
      </small>

      <button class="btn btn-primary" [disabled]="isSaving" (click)="saveNotificationSettings()">
        <i class="bi bi-floppy-fill me-2"></i>
        {{ isSaving ? 'Saving...' : 'Save Preferences' }}
      </button>
    </div>
  }
</div>
